/*=============================================== CardColor component ===============================================*/

import { Text } from "tsx-library-julseb"

import { StyledCard, Content, Square } from "./styles"
import type { CardColorProps, ColorItemType } from "./types"

const CardColor = ({ color, overlay }: CardColorProps) => {
    const { name, variable, css } = color || overlay

    const colorItems: ColorItemType[] = [
        {
            title: "Variable",
            value: variable,
        },
        {
            title: "CSS",
            value: css,
        },
        {
            title: "Hex",
            value: color?.hex || "",
        },
        {
            title: "RGB",
            value: color?.rgb || "",
        },
    ]

    const overlayItems: ColorItemType[] = [
        {
            title: "Variable",
            value: variable,
        },
        {
            title: "CSS",
            value: css,
        },
        {
            title: "Value",
            value: overlay?.value.toString() || "",
        },
    ]

    const list = (arr: ColorItemType[]) =>
        arr.map(({ title, value }) => (
            <Text key={title}>
                <Text tag="strong">{title}</Text>: {value}
            </Text>
        ))

    return (
        <StyledCard border={{ width: 1 }} gap="m">
            <Square
                style={{
                    ["--card-color" as any]: css,
                }}
            />

            <Content flexDirection="column" alignItems="stretch">
                <Text tag="h6">{name}</Text>

                {color ? list(colorItems) : list(overlayItems)}
            </Content>
        </StyledCard>
    )
}

export default CardColor
